import React from "react";

import PropTypes from "prop-types";

import ReactLogo from "./maintainceIcon";

function BannerContent({ message }) {
  return (
    <div
      style={{
        width: "100%",
        margin: "auto",
        padding: "10px 20px",
        color: "#524f4f",
        textAlign: "center",
        fontSize: "1.2rem",
        fontWeight: "bold",
        gap: "2rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <ReactLogo fillColor="#524f4f" />
      {message}
    </div>
  );
}

export default BannerContent;

BannerContent.propTypes = {
  message: PropTypes.string,
};

BannerContent.defaultProps = {
  message: "",
};
